import cx from 'classnames'
import { Button, Icon } from '@vzmi/shp_shared_compo'

import styles from './ExportButton.css'

const ExportButton = ({ className, children = '下載', ...props }) => {
  const clz = cx(styles.ExportButton, {
    [className]: !!className
  })
  return (
    <Button
      className={clz}
      size='small'
      color='purple'
      {...props}
    >
      {children}
    </Button>
  )
}

// 使用 download icon 加純文字的按鈕
export const IconExportButton = props => {
  const {
    disabled,
    className,
    label,
    onClick,
    ...otherProps
  } = props

  const clz = cx(styles.IconExportButton, {
    [className]: !!className,
    [styles.disabledIconExportButton]: disabled
  })

  const clickHandler = disabled
    ? () => {}
    : onClick

  const iconColor = disabled
    ? '#979ba7'
    : '#5478fc'

  return (
    <div
      className={clz}
      onClick={clickHandler}
      {...otherProps}
    >
      <Icon
        color={iconColor}
        name={'download'}
        size={16}
      />
      {label}
    </div>
  )
}

export default ExportButton
